module.exports = __webpack_public_path__ + "static/media/hotel-13.d310bb87.jpg";